import React from 'react';

const TopDisclaimer = props => (
  <p><i>Disclaimer: OLLIE is a free educational resource that provides general legal information for entrepreneurs in California. It does <b>not</b> provide legal advice. Please engage a licensed attorney for advice on your particular situation.</i></p>
)

export default TopDisclaimer;


// WEBPACK FOOTER //
// ./src/components/TopDisclaimer.js